export interface DomainContext {
  subdomain: string | null
  isAdmin: boolean
  isCountry: boolean
}

export function useDomain(): DomainContext {
  const hostname = window.location.hostname // e.g. "in.youngnewsnetwork.com" or "in.ynn.local"

  // Dev override via query param: ?dev_domain=in
  const devParam = new URLSearchParams(window.location.search).get('dev_domain')

  let subdomain: string | null = devParam

  if (!subdomain) {
    const parts = hostname.split('.')
    // "in.youngnewsnetwork.com" → parts = ["in", "youngnewsnetwork", "com"]
    // "in.ynn.local" → parts = ["in", "ynn", "local"]
    // "localhost" → parts = ["localhost"] — no subdomain
    if (parts.length >= 3) {
      subdomain = parts[0]
    }
  }

  const isAdmin = subdomain === 'admin'
  // Any subdomain that isn't admin or www is treated as a country
  const isCountry = !isAdmin && !!subdomain && subdomain !== 'www'

  return {
    subdomain: isCountry ? subdomain : null,
    isAdmin,
    isCountry,
  }
}
